import { Tooltip } from "react-tooltip";
import styled from "styled-components";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { Row, TinyIcon } from "core/styles";

const HeaderWithTooltipContainer = styled(Row)`
  gap: 5px;
  align-items: center;
  min-width: 40px;

  svg {
    color: var(--text-header);
  }
`;

const HeaderWithTooltip = ({
  info,
  children,
  clickable = false,
  iconStyle,
  style,
  tooltipPlace = "bottom-end",
}) => {
  return (
    <HeaderWithTooltipContainer style={{ ...style }}>
      {children}{" "}
      <TinyIcon
        icon={faCircleInfo}
        data-tooltip-id={children}
        style={{ ...iconStyle, cursor: "pointer" }}
      />
      <Tooltip
        // isOpen={true}
        id={children}
        positionStrategy="fixed"
        place={tooltipPlace}
        clickable={clickable}
        style={{ zIndex: 100000 }}
        classNameArrow="tooltip-arrow"
        offset={8}
      >
        {info}
      </Tooltip>
    </HeaderWithTooltipContainer>
  );
};

export default HeaderWithTooltip;
